var _style, _g, _path, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoyalDsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.4 273.4",
    style: {
      enableBackground: "new 0 0 273.4 273.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#233C4B;}\n\t.st1{fill:url(#path251_00000163767983022980784720000012761718887421649572_);}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#path299_00000153681993892442192250000004256122849101628607_);}\n\t.st4{fill:url(#path319_00000060736004880564928220000017244176055445735071_);}\n\t.st5{fill:url(#SVGID_00000066501231967160623230000000574629670585649311_);}\n\t.st6{fill:url(#path369_00000101088021722020529900000001375371114013041291_);}\n\t.st7{fill:url(#path387_00000159437777691709040400000014395349137772570784_);}\n\t.st8{fill:url(#path405_00000036964083238551798660000011755967430963342243_);}\n\t.st9{fill:url(#path423_00000039097037595580194330000001089541336287734195_);}\n\t.st10{fill:url(#path443_00000181780289516732963830000005226602816393186492_);}\n\t.st11{fill:#27404F;}\n\t.st12{fill:url(#path465_00000101822636065598707500000009303478896515037096_);}\n\t.st13{fill:#1F3643;}\n\t.st14{fill:#324957;}\n\t.st15{fill:#6C6C6C;}\n\t.st16{fill:#3E5360;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g221"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g227",
    transform: "translate(499.165,148.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path229",
    className: "st0",
    d: "M-276.8-21.9V5.7c0,0.3-0.1,0.4-0.3,0.5s-0.3,0.3-0.5,0.3h-6.4c0,0,0-11.3,0-13.7 c0-1.5,0.4-6,0.5-6.8l0,0c0-0.1-0.1-0.1-0.1,0l0,0L-291-2.1c0,0.1-0.1,0.1-0.1,0.3c-0.1,0.1-0.3,0.3-0.5,0.3h-1.8l0,0h-1.8 c-0.1,0-0.4-0.1-0.5-0.3c0,0-0.1-0.1-0.1-0.3l-7.4-11.9l0,0h-0.1l0,0c0.1,0.8,0.7,5.3,0.5,6.8c0,2.3,0,13.7,0,13.7h-6.4 c-0.1,0-0.4-0.1-0.5-0.3s-0.3-0.3-0.3-0.5v-27.6c0-0.4,0.4-0.8,0.8-0.8h7.8c0.3,0,0.5,0.1,0.7,0.4c0,0,5.5,9.6,6.1,10.7 c0.4,0.7,1.1,2.5,1.1,2.5l0,0l0,0l0,0c0,0,0,0.1,0.1,0.1l0,0l0,0c0,0,0.1,0,0.1-0.1l0,0l0,0l0,0c0-0.1,0.7-1.8,1.1-2.5 c0.7-1.1,6.1-10.7,6.1-10.7c0.1-0.3,0.4-0.4,0.7-0.4h7.8C-277.2-22.6-276.8-22.3-276.8-21.9z M-323.1-11.5c-0.1,0-0.3-0.1-0.4-0.1 c-2-0.7-3.8-1.8-3.8-3.1c0-0.8,0.3-1.5,0.7-1.9c0.5-0.5,1.6-0.8,2.3-0.8c3.3,0,6.3,1.5,6.3,1.5l1.8-4.8c0-0.1,0-0.4,0-0.5 c-0.1-0.1-0.3-0.3-0.4-0.4l0,0c-1.5-0.5-4.4-1.5-7.7-1.5c-6.3-0.1-10.1,3.1-10.1,8.3c0,6.1,5.2,8.2,7,8.9c0.3,0.1,0.5,0.3,1,0.4 c1.1,0.4,2.3,1,3.3,1.5c1.1,0.7,1.2,1.9,1.1,2.6c-0.4,2.3-3,2.7-4.9,2.5c-3.8-0.5-5.7-1.6-5.7-1.6l-1.6,4.8c-0.1,0.4,0,0.7,0.4,1 c0,0,3.6,1.8,7.9,1.8c5.1,0,11.1-2.5,11.1-9.3C-315.3-8.8-320.8-10.7-323.1-11.5z M-354,0.7c-2.5,0.1-4,0-4.8-0.3v-16.8 c0.8-0.1,2.6-0.3,4.9-0.1c3,0.1,7.9,1.1,7.9,7.9S-351,0.5-354,0.7z M-346.4-21.3c-4.1-1.8-9.2-1.9-12-1.8 c-5.9,0.3-7.7,0.7-7.7,0.7V5.4c0,0.3,0.3,0.7,0.5,0.7c0,0,2.6,0.8,7.2,1c5.9,0.1,10.1-0.7,13.3-2.7c4.2-2.9,6.4-7,6.4-12.8 C-338.6-14.8-341.2-19.2-346.4-21.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g231_00000033370984500273172990000009729539444543478678_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g233_00000088853620879726537310000005646306368325232799_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g239_00000003074107466100447250000003729543519665874567_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path251_00000039133701446486344440000013641315987883100091_",
    gradientUnits: "userSpaceOnUse",
    x1: -841.211,
    y1: 70.4541,
    x2: -839.8439,
    y2: 70.4541,
    gradientTransform: "matrix(-20.8657 38.2645 -38.2535 -20.8717 -14731.8076 33762.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1214,
    style: {
      stopColor: "#F0F2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8418,
    style: {
      stopColor: "#909EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#919FA6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path251_00000150820112503341306550000001327935311389738427_",
    style: {
      fill: "url(#path251_00000039133701446486344440000013641315987883100091_)"
    },
    d: " M118,98.9c-9.6,2.9-14.1,7.2-12.7,19.7c1.2,8.1,0.5,14.9-0.7,19.5c-0.3,1-0.5,1.8-0.8,2.5c-0.1,0.3-0.1,0.5-0.3,0.8 c-0.7,1.5-2.3,4.6-3.1,5.7c-0.5,1-1.9,2.3-3.7,2.3c-1.6,0-5.3-0.1-6.3-0.1c-1,0-2.6,0.1-2.6,0.1c2.5,2.6,6.7,5.1,12.4,5.1 c4.2,0,9.2-1.2,13.8-4.5C131,138,126.7,107.4,118,98.9"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.4039,
    y1: 957.4161,
    x2: 84.4039,
    y2: 910.4854,
    gradientTransform: "matrix(1 0 0 1 0 -782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AEB8BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2704,
    style: {
      stopColor: "#9DA8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#344B5A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.1,128.5c-11.8,3.7-17.9,18.3-12.7,32.8c0.4,1.2,1,2.3,1.5,3.6c7.2,15,21.7,11.6,21.7,11.6 s5.2-10-4.4-17.6c-6.7-5.3-10.2-10.8-7-19.1c0.1-0.4,0.4-1,0.5-1.4c0-0.1,0.1-0.1,0.1-0.3c1.1-2.5,2.9-4.9,3.8-6.4 c0.7-1.1,1.5-1.5,3.4-1.6c1.6-0.1,5.7,0,6.8,0c1.6,0.1,2.3,0.4,3.1,1.6c0,0,0,0,0,0.1C97.8,127.3,90.3,126.4,83.1,128.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g279_00000052072477011328901580000002414765154796112572_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g281_00000166646097448245634740000015273008745773708693_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g287_00000076592426884160408890000001930272366909939091_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path299_00000034056433002472942670000016921382928248288910_",
    gradientUnits: "userSpaceOnUse",
    x1: -931.0903,
    y1: 87.3051,
    x2: -929.7236,
    y2: 87.3051,
    gradientTransform: "matrix(-18.3784 -17.7528 17.7478 -18.3837 -18558.1875 -14760.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AA5AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#939FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8872,
    style: {
      stopColor: "#61747F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62737E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path299_00000067224226622704109540000007475281342075068042_",
    style: {
      fill: "url(#path299_00000034056433002472942670000016921382928248288910_)"
    },
    d: " M91.2,149.6c-1.2-0.1-2.2-0.1-2.9-0.4l0,0c-0.5-0.3-1.1-0.5-1.5-1.2c-1-1.5-3-4.9-3.7-6.4c-0.8-1.5-0.7-2.2-0.1-3.4 c1.1-2.5,2.9-4.9,3.8-6.4c0,0,0-0.1,0.1-0.1c-0.5,0.4-4.5,3.8-7.2,7.5c-4.9,6.7-3.6,16.1,2,21.9c4.1,4.2,8.9,5.1,12.6,5.1 c6.7-0.1,12.8-5.5,12.8-5.5C104.9,154.1,98.6,150.5,91.2,149.6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g301_00000042703381948335674640000009767505831089122222_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g303_00000005982350402291066650000014461950519933182141_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g309_00000009559714985747535730000013170519106373600656_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path319_00000126321486006896328560000013747098428195289234_",
    gradientUnits: "userSpaceOnUse",
    x1: -800.2927,
    y1: 69.7435,
    x2: -798.926,
    y2: 69.7435,
    gradientTransform: "matrix(-9.998314e-07 25.2094 -25.2022 -1.000117e-06 1843.132 20306.4492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#172934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9214,
    style: {
      stopColor: "#475C68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A5F6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path319_00000026139154523301289880000017295680176698512021_",
    style: {
      fill: "url(#path319_00000126321486006896328560000013747098428195289234_)"
    },
    d: " M94.2,166C94.4,166,94.4,166,94.2,166c-0.7-2.3-2.2-4.8-5.1-7.1c-6.7-5.3-10.2-10.8-7-19.1c0.1-0.4,0.4-1,0.5-1.4 c0-0.1,0.1-0.1,0.1-0.3c1.1-2.5,2.9-4.9,3.8-6.4c0,0,0-0.1,0.1-0.1c-0.5,0.4-4.5,3.8-7.2,7.5c-4.9,6.7-3.6,16.1,2,21.9 C85.7,165.2,90.5,166.1,94.2,166"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067940468964638040770000012756208181564859833_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.787,
    y1: 876.9727,
    x2: 95.2699,
    y2: 947.5985,
    gradientTransform: "matrix(1 0 0 1 0 -782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9EDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02938988,
    style: {
      stopColor: "#E9EDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5969,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5969,
    style: {
      stopColor: "#E9EDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EDF1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067940468964638040770000012756208181564859833_)"
    },
    d: "M111.4,117.7c-3.3-9.3-10.9-17.1-21-19.7 c-16.8-4.5-31,1.5-38.5,11.8c0,0,5.6,9,20.1,8.2c9.4-0.5,19.1,0.4,26,10.1c0.7,1.1,1.4,2,2,3c0.1,0.1,0.1,0.1,0.3,0.3 c0.8,1.1,1.9,2.9,3.6,6c0.5,1.1,0.5,2.5,0,3.8c-0.7,1.5-2.3,4.6-3.1,5.7c-0.5,0.8-1.8,2.2-3.4,2.3l0,0c5.6-0.3,10.2-3.8,13.3-9.2 C113.9,134,114.2,125.3,111.4,117.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g349_00000029762684331052692950000017319183404600630963_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g351_00000105413233315996058960000009149974257848749464_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g357_00000083056713866248208140000006692685736111783068_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path369_00000114050093674857233840000002641782843916940955_",
    gradientUnits: "userSpaceOnUse",
    x1: -816.3933,
    y1: 89.1016,
    x2: -815.0267,
    y2: 89.1016,
    gradientTransform: "matrix(6.4039 36.3293 -36.3189 6.4058 8540.3809 29197.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6BFC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5894,
    style: {
      stopColor: "#5E707B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#5E707B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#253D4B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path369_00000101810172899776183130000004923110896265303215_",
    style: {
      fill: "url(#path369_00000114050093674857233840000002641782843916940955_)"
    },
    d: " M105,121.4c-3.1-5.9-10.7-12.7-23.5-12.7c-18,0-27.7,13.7-27.7,26.9c0,10.5,5.7,20.9,16.5,25.8c-4-16,3.1-30.5,19.5-31.4 c0.1,0,0.1,0,0.3,0c1.6-0.1,5.7,0,6.8,0c1.6,0.1,2.3,0.4,3.1,1.6c0.8,1.1,1.9,2.9,3.6,6c0.5,1.1,0.5,2.5,0,3.8 c-0.7,1.2-1.9,3.8-2.7,5.2c0.1-0.1,4-4.6,5.2-7.7C108.7,132.1,106.8,124.6,105,121.4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g371_00000013896734391858257050000015314015067850278023_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g373_00000144305650461613964820000011732155056695833742_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g379_00000165208495729975490420000003816809657844027540_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path387_00000104691121872794491500000004525745984569155512_",
    gradientUnits: "userSpaceOnUse",
    x1: -939.0571,
    y1: 151.8148,
    x2: -937.6905,
    y2: 151.8148,
    gradientTransform: "matrix(-9.998314e-07 -20.3969 20.3911 -1.000117e-06 -2990.4802 -19009.5195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61747F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path387_00000151523845445922503850000000635253155580178847_",
    style: {
      fill: "url(#path387_00000104691121872794491500000004525745984569155512_)"
    },
    d: " M97.1,149.5c5.6-0.3,10.2-3.8,13.3-9.2c3.6-6.3,3.8-15,1.2-22.5c-1.2-3.4-3.1-6.7-5.5-9.6c-1,2.6-1.1,6-0.7,10.2 c1.1,8.2,0.4,15-0.8,19.7c-0.3,1-0.5,1.8-0.8,2.5c-0.1,0.3-0.1,0.5-0.3,0.8c-0.7,1.5-2.3,4.6-3.1,5.7 C100,148.1,98.7,149.3,97.1,149.5L97.1,149.5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g389_00000129173837187263113210000007967167871685032583_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g391_00000065761519652761642550000000389818236195187353_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g397_00000106856607456040585800000011870417351429182597_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path405_00000087379901332124001310000014940352525869497520_",
    gradientUnits: "userSpaceOnUse",
    x1: -819.2186,
    y1: 130.6939,
    x2: -817.852,
    y2: 130.6939,
    gradientTransform: "matrix(31.6187 18.2604 -18.2552 31.6277 28353.6543 10935.8887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#536772"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path405_00000097476227362188904000000006140426307466772652_",
    style: {
      fill: "url(#path405_00000087379901332124001310000014940352525869497520_)"
    },
    d: " M106,139.1c2.7-7,0.7-14.5-1-17.6c-3.1-5.9-10.7-12.7-23.5-12.7c-8.7,0-15.4,3.1-20.2,7.9c2.7,1,6.3,1.6,10.5,1.4 c9.4-0.5,19.1,0.4,26,10.1c0.7,1.1,1.4,2,2,3l0,0l0.1,0.1l0.1,0.1c0.8,1.1,1.9,2.9,3.6,6c0.5,1.1,0.5,2.5,0,3.8 c-0.7,1.2-1.9,3.8-2.7,5.2C101,146.4,104.9,141.9,106,139.1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g407_00000131347533297438665810000014981893551779955350_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g409_00000023966439370094666710000014352945931542955916_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g415_00000067220699916853503320000014146759285999202740_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path423_00000026162389060425588990000010753111507207751833_",
    gradientUnits: "userSpaceOnUse",
    x1: -995.9903,
    y1: 106.5369,
    x2: -994.6237,
    y2: 106.5369,
    gradientTransform: "matrix(-6.9113 -11.7646 11.7613 -6.9133 -8034.6699 -10815.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7B1B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#495D6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path423_00000107565308191084687780000000372861359050434979_",
    style: {
      fill: "url(#path423_00000026162389060425588990000010753111507207751833_)"
    },
    d: " M116.5,152.6c-2.3-1.5-3.7-4.9-3.6-8.1c0.1-3.6-1.9-3-1.9-3s-4.4,7.9-14.2,7.9l0,0c-1.8,0-4.9-0.1-6.3-0.1 c-6.3,0-12.4,1.2-17.5,7.7c0,0,5.3-0.3,15.7,2.9C108,165.9,117.6,154.6,116.5,152.6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g425_00000007421612488857084920000001892080896311358101_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g427_00000178926390805831034450000013743948555279062177_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g433_00000134214001523983464990000000819023675967648444_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path443_00000046310623272059360260000005929773447670773683_",
    gradientUnits: "userSpaceOnUse",
    x1: -1076.3685,
    y1: 106.9296,
    x2: -1075.0018,
    y2: 106.9296,
    gradientTransform: "matrix(-4.3125 -7.3411 7.339 -4.3138 -5320.5894 -7284.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#697985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#4F636F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#495D6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path443_00000158723625169463817440000000955672546710254508_",
    style: {
      fill: "url(#path443_00000046310623272059360260000005929773447670773683_)"
    },
    d: " M111,141.5c0,0-4.2,7.8-14.1,7.9h-0.1c-0.5,0-1.2,0-1.9,0c-1.6,0-3.4-0.1-4.4-0.1c-0.4,0-0.7,0-1.1,0c-0.5,0-1.1,0-1.4,0 c-0.1,0-0.1,0-0.3,0c2.5,2.6,6.7,5.1,12.4,5.1c4.2,0,9.2-1.2,13.8-4.5c0,0,0,0,0.1-0.1c-0.8-1.6-1.4-3.6-1.2-5.5 C113.2,141,111,141.5,111,141.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g445_00000024706527584360169930000012017141847210595247_",
    transform: "translate(91.669,141.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path447_00000107586410054553473920000018420981943144061609_",
    className: "st11",
    d: "M-8.6-12.5 C-20.3-8.8-26.5,5.8-21.3,20.3c-4-16,3.1-30.5,19.5-31.4c0.1,0,0.1,0,0.3,0c1.6-0.1,5.7,0,6.8,0C7-11,7.7-10.8,8.5-9.5 c0,0,0,0,0,0.1C6.2-13.8-1.3-14.9-8.6-12.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g449_00000026123331925041346140000004151597153302580910_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g451_00000084499196398477370300000004630413199117196455_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g457_00000128445201925496345640000002635165543915057810_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path465_00000093861969360759111540000004801655343743151005_",
    gradientUnits: "userSpaceOnUse",
    x1: -818.1874,
    y1: 181.6323,
    x2: -816.8207,
    y2: 181.6323,
    gradientTransform: "matrix(20.8315 0 0 20.8374 17115.8672 -3629.2009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#324957"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62737E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path465_00000070081990302540448010000011188422083543802768_",
    style: {
      fill: "url(#path465_00000093861969360759111540000004801655343743151005_)"
    },
    d: " M107.1,160.5c-2.2-6.4-8.5-10-15.9-10.9c-0.5,0-1-0.1-1.4-0.1c-6,0.1-11.9,1.5-16.7,7.7c0,0,5.3-0.3,15.7,2.9 C96.4,162.3,102.6,161.9,107.1,160.5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g467_00000152957107537746870610000015918813603788040851_",
    transform: "translate(158.291,156.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path469_00000170267083734277285040000015589518637316713089_",
    className: "st13",
    d: "M-52.5-33.2c0.4,6-0.3,11.1-1.2,14.8 c-0.3,1-0.5,1.8-0.8,2.5l0,0c0,0.1-0.1,0.3-0.1,0.4c0,0,0,0,0,0.1s-0.1,0.3-0.1,0.3l0,0c-0.7,1.2-1.9,3.8-2.7,5.2 c0.3-0.3,4-4.6,5.2-7.7C-50-23.2-51-29.5-52.5-33.2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g471_00000160181072449774816590000013781441091354049706_",
    transform: "translate(114.883,47.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path473_00000148648801528388734970000009179920229323246514_",
    className: "st14",
    d: "M-23.8,112.8c-0.5-0.5-1.2-1.1-1.9-1.6 c-3.3-2.6-5.7-5.3-7.1-8.2c-3.1,1.1-6.3,3-9,6.4c0,0,5.3-0.3,15.7,2.9C-25.5,112.4-24.5,112.7-23.8,112.8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g495_00000126289288805054329170000017485579238125960082_",
    transform: "translate(111.271,80.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path497_00000121262619244739299120000013684366923234739894_",
    className: "st16",
    d: "M-21.5,69.1c-0.1,0-0.1,0-0.3,0 c-0.4,0-1,0-1.4,0.1c-0.1,0-0.1,0-0.3,0c2.5,2.6,6.7,5.1,12.4,5.1c0.8,0,1.6,0,2.6-0.1c-3-2.7-7.2-4.2-11.8-4.9 C-20.6,69.3-21.1,69.1-21.5,69.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalDsm);
export default __webpack_public_path__ + "static/media/RoyalDSM.4dbae35fde5bbde22edb440603506c1c.svg";
export { ForwardRef as ReactComponent };